import PropTypes from 'prop-types';
import Core from './core';

function App({ children, ...props }) {
  return <Core {...props}>{children}</Core>;
}
App.propTypes = {
  children: PropTypes.node.isRequired,
};
export default App;
